import React, { useContext } from "react";

import isEmpty from "lodash.isempty";
import { observer } from "mobx-react";
import styled from "styled-components";

import ComponentContext from "../../../contexts/ComponentContext";
import breakpoints from "../../constants";

const StyledBenefitsList = styled.div`
  background-color: ${({ backgroundColor }) => backgroundColor};
  position: relative;
  margin-top: -1px;
  flex-wrap: wrap;

  border-right: ${({ isFullWidth, border }) =>
    // eslint-disable-next-line no-nested-ternary
    isFullWidth ? "none" : isEmpty(border) ? "1px solid white" : border};

  @media (min-width: ${breakpoints.DESKTOP}) {
    flex-wrap: nowrap;
    .keypoint-box:first-child {
      border-left: ${({ border, isFullWidth }) =>
        // eslint-disable-next-line no-nested-ternary
        isFullWidth ? "none" : isEmpty(border) ? "1px solid white" : border};
    }
  }

  @media (max-width: ${breakpoints.DESKTOP}) {
    justify-content: center;

    .keypoint-box:nth-child(3n),
    .keypoint-box:last-child {
      border-right: ${({ border }) =>
        isEmpty(border) ? "1px solid white" : border};
    }
  }

  &:before {
    content: "";
    background-color: ${({ backgroundColor }) => backgroundColor};
    width: 1px;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
  }

  &:after {
    content: "";
    background-color: ${({ backgroundColor }) => backgroundColor};
    width: 1px;
    height: 100%;
    position: absolute;
    right: 0;
    top: 0;
  }
`;

const StyledBenefit = styled.div`
  color: ${({ textColor }) => (isEmpty(textColor) ? "white" : textColor)};

  border-left: ${({ border }) =>
    isEmpty(border) ? "1px solid white" : border};
  border-top: ${({ border }) => (isEmpty(border) ? "1px solid white" : border)};
  min-height: 90px;
  text-align: center;
  font-weight: bold;
  flex: 0 0 33.33%;
  min-width: 0;
  font-size: 11px;

  @media (max-width: ${breakpoints.DESKTOP}) {
    flex: 1 0 33.33%;
    border-bottom: ${({ border, hasBottomBorder }) => {
      if (hasBottomBorder) return isEmpty(border) ? "1px solid white" : border;
      return "none";
    }};
  }

  @media (min-width: ${breakpoints.DESKTOP}) {
    flex: 1 1 25%;
    border-top: none;
    font-size: 1rem;
  }
`;

function KeyPointsBar() {
  const { keyPointBackgroundColor, fullWidth, border, textColor, keyPoints } =
    useContext(ComponentContext);

  if (isEmpty(keyPoints)) {
    return null;
  }

  // WE NEED TO KNOW HOW MANY BOXES ARE ON THE LAST ROW
  // SO WE CAN ADD THE BOTTOM BORDER FROM THOSE BOXES
  let boxesOnLastRow = keyPoints.length % 3;

  if (boxesOnLastRow === 0) boxesOnLastRow = 3;

  return (
    <StyledBenefitsList
      backgroundColor={keyPointBackgroundColor}
      border={border}
      className="d-flex"
      data-testid="benefits-list"
      isFullWidth={fullWidth}
    >
      {keyPoints.map(({ keyPoint, id }, index) => (
        <StyledBenefit
          key={`keypoint-${id}`}
          border={border}
          isFullWidth={fullWidth}
          className="py-4 px-3 d-flex align-items-center justify-content-center text-uppercase keypoint-box"
          hasBottomBorder={index >= keyPoints.length - boxesOnLastRow}
          textColor={textColor}
        >
          {keyPoint}
        </StyledBenefit>
      ))}
    </StyledBenefitsList>
  );
}

export default observer(KeyPointsBar);
